module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', {
    ref: "screenLayout"
  }, [_c('template', {
    slot: "header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "flat": "",
      "dark": "",
      "dense": "",
      "xxstyle": "z-index:8;position:fixed;"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_c('span', {
    staticClass: "clickable heading-button",
    on: {
      "click": function($event) {
        return _vm.showTeamDetails(_vm.activeTeam)
      }
    }
  }, [_vm._v(_vm._s(_vm.activeTeam.name))]), _vm._v(" "), (_vm.activeTeam.name && _vm.activeCollection.name) ? _c('span', [_vm._v(">")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clickable heading-button",
    on: {
      "click": function($event) {
        return _vm.showCollectionDetails(_vm.activeCollection)
      }
    }
  }, [_vm._v(_vm._s(_vm.activeCollection.name))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({}, on), [_vm._v("more_vert")])]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": _vm.showBulkUpdate
    }
  }, [_c('v-list-item-title', [_vm._v("Bulk Update")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.rightColumnActive = !_vm.rightColumnActive
      }
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "left"
  }, [_c('v-select', {
    staticClass: "ma-2",
    attrs: {
      "value": _vm.teamId,
      "items": _vm.teamsItems.concat( [{
        value: 'add',
        text: 'Add New Team'
      }]),
      "single-line": ""
    },
    on: {
      "change": _vm.selectTeam
    }
  }), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, _vm._l((_vm.collections), function(collection) {
    return _c('v-list-item', {
      key: collection._id,
      on: {
        "click": function($event) {
          return _vm.selectCollection(collection)
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("folder")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(collection.name))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("Collection")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("info")])], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "color": "grey lighten-2"
    },
    on: {
      "click": function($event) {
        return _vm.showCollectionDetails(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "elevation-3 ma-3"
  }, [_c('div', {
    staticClass: "white-background pa-3",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Fields")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "small": "",
      "right": "",
      "bottom": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showFieldDetails(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "light-background pa-3"
  }, _vm._l((_vm.collection.fields), function(field) {
    return _c('div', {
      key: field._id,
      staticClass: "field hoverable clickable",
      on: {
        "click": function($event) {
          return _vm.showFieldDetails(field)
        }
      }
    }, [_vm._v("\n                " + _vm._s(field.name) + " - "), _c('flag', [_vm._v(_vm._s(field.type))])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "elevation-3 ma-3"
  }, [_c('div', {
    staticClass: "white-background pa-3",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Data")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Search"
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "small": "",
      "right": "",
      "bottom": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showDataDetails(null, _vm.collection.fields)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "light-background pa-3"
  }, [_c('table', {
    staticClass: "full-width",
    staticStyle: {
      "border-collapse": "collapse"
    }
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, _vm._l((_vm.collection.fields), function(field) {
    return _c('td', [_vm._v(_vm._s(field.name))])
  }), 0), _vm._v(" "), _vm._l((_vm.collection.data), function(row) {
    return _c('tr', {
      staticClass: "clickable hoverable",
      on: {
        "click": function($event) {
          return _vm.showDataDetails(row, _vm.collection.fields)
        }
      }
    }, _vm._l((_vm.collection.fields), function(field) {
      return _c('td', [_c('div', {
        staticStyle: {
          "max-height": "60px",
          "overflow": "auto",
          "min-width": "60px"
        }
      }, [_c('Merger', {
        attrs: {
          "row": row,
          "field": field
        }
      })], 1)])
    }), 0)
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "elevation-3 ma-3"
  }, [_c('div', {
    staticClass: "white-background pa-3",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Actions")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "absolute": "",
      "small": "",
      "right": "",
      "bottom": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showActionDetails(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "light-background pa-3"
  }, [_c('table', {
    staticClass: "full-width",
    staticStyle: {
      "border-collapse": "collapse"
    }
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v("Field")]), _vm._v(" "), _c('td', [_vm._v("Type")])]), _vm._v(" "), _vm._l((_vm.collection.actions), function(action) {
    return _c('tr', {
      key: action._id,
      staticClass: "clickable hoverable",
      on: {
        "click": function($event) {
          return _vm.showActionDetails(action)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(action.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.field))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.type))])])
  })], 2)])]), _vm._v(" "), _c('template', {
    slot: "right"
  }), _vm._v(" "), _c('TeamDialog', {
    attrs: {
      "settings": _vm.teamDialog.settings,
      "team": _vm.teamDialog.team
    },
    on: {
      "save": _vm.saveTeam
    }
  }), _vm._v(" "), _c('CollectionDialog', {
    attrs: {
      "settings": _vm.collectionDialog.settings,
      "collection": _vm.collectionDialog.collection
    },
    on: {
      "save": _vm.saveCollection
    }
  }), _vm._v(" "), _c('FieldDialog', {
    attrs: {
      "settings": _vm.fieldDialog.settings,
      "field": _vm.fieldDialog.field
    },
    on: {
      "save": _vm.saveField,
      "delete": _vm.deleteField
    }
  }), _vm._v(" "), _c('ActionDialog', {
    attrs: {
      "settings": _vm.actionDialog.settings,
      "action": _vm.actionDialog.action
    },
    on: {
      "save": _vm.saveAction,
      "delete": _vm.deleteAction
    }
  }), _vm._v(" "), _c('DataDialog', {
    attrs: {
      "settings": _vm.dataDialog.settings,
      "row": _vm.dataDialog.row,
      "fields": _vm.dataDialog.fields
    },
    on: {
      "save": _vm.saveData,
      "delete": _vm.deleteData
    }
  }), _vm._v(" "), (_vm.bulkUpdateDialog.settings.visible) ? _c('BulkUpdateDialog', {
    attrs: {
      "settings": _vm.bulkUpdateDialog.settings
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38cdaa4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/system/SystemEditor.vue
// module id = 2506
// module chunks = 1